<template>
  <div
    class="flex items-center border-b border-gray-100 py-2"
    :style="{ paddingLeft: (depth * 24 + 16 + 24) + 'px' }"
  >
    <FontAwesomeIcon :icon="['fas', 'plus']" class="text-[10px] text-gray-300 mr-2" />
    <input
      ref="input"
      v-model="title"
      class="flex-1 text-sm border-none outline-none bg-transparent placeholder-gray-300"
      :placeholder="'Add ' + childTypeName + '...'"
      @keydown.enter="submit"
      @keydown.escape="$emit('cancel')"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getChildType, CHILD_TYPE_LABELS } from './support_constants.js';

export default {
  name: 'Support_QuickAdd',
  components: { FontAwesomeIcon },
  props: {
    parentNode: { type: Object, required: true },
    depth: { type: Number, required: true },
    requirementTypes: { type: Array, default: () => [] },
  },
  emits: ['created', 'cancel'],
  data() {
    return { title: '' };
  },
  computed: {
    childType() {
      return getChildType(this.parentNode.requirement_type_name, this.requirementTypes);
    },
    childTypeName() {
      return CHILD_TYPE_LABELS[this.parentNode.requirement_type_name] || 'child';
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus());
  },
  methods: {
    async submit() {
      if (!this.title.trim()) return;
      if (!this.childType.typeId) {
        this.$emit('cancel');
        return;
      }
      this.$emit('created', {
        parent: this.parentNode.id,
        tenant: this.parentNode.tenant,
        title: this.title.trim(),
        requirement_type: this.childType.typeId,
        status: 'draft',
        priority: this.parentNode.priority || 'none',
      });
      this.title = '';
    },
    onBlur() {
      if (!this.title.trim()) {
        this.$emit('cancel');
      }
    },
  },
};
</script>
